import React from 'react';
import * as styled from './styled/Option.styled';

export interface OptionProps {
    value: string;
    onClick?: (value: string) => void;
}

export const Option: React.FC<OptionProps> = ({ children, onClick, value }) => {
    return (
        <styled.Option key={value} onClick={() => onClick?.(value)}>
            {children}
        </styled.Option>
    );
};
